import axios from 'axios'

const service = axios.create({
  // 请求地址
  baseURL: process.env.VUE_APP_API,
  // 超时时间
  timeout: 3 * 1000,
})


// 请求拦截器
service.interceptors.request.use(function (config) {
  return config
}, function (error) {
  return Promise.reject(error)
})

// 返回拦截器
service.interceptors.response.use(function (response) {
  const responseData = response.data
  const { code, message } = responseData
  if (code === undefined) {
    return responseData
  } else {
    switch (code) {
      case 0: // 没有错误
        return responseData
      default:
        // const error = new Error(message)
        // throw error
        return responseData
    }
  }
}, function (error) {
  // if (error.code == 'ERR_BAD_RESPONSE') {
  //   window.alert('服务器错误')
  // }
  return Promise.reject(error)
})

export default service